import _ from 'lodash';
import { Deferred } from 'simply-deferred';

module.exports = {

    css: {
        loadedFiles: [],

        loadDeferred(fileName) {

            let found = false;

            fileName = fileName + '?' + gdConfig.build;

            _.each(this.loadedFiles,(key,path)=>{
                if (path === fileName) {
                    found = true;
                }
            });

            if (!found) {

                const deferredLoader = Deferred(); // create new deferred object

                this.loadedFiles.push(fileName);

                const head = document.getElementsByTagName( 'head' )[0]; // reference to document.head for appending/ removing link nodes
                const link = document.createElement( 'link' );           // create the link node

                link.setAttribute( 'href', fileName );
                link.setAttribute( 'rel', 'stylesheet' );
                link.setAttribute( 'type', 'text/css' );

                let sheet, cssRules;
                // get the correct properties to check for depending on the browser
                if ( 'sheet' in link ) {
                    sheet = 'sheet'; cssRules = 'cssRules';
                }
                else {
                    sheet = 'styleSheet'; cssRules = 'rules';
                }

                let interval_id, timeout_id;

                const checkLoaded = ()=>{
                    const s = link[sheet];
                    return  s && s[cssRules].length &&
                            s[cssRules][s[cssRules].length-1].selectorText === '.load_done';
                };

                interval_id = setInterval(()=>{                    // start checking whether the style sheet has successfully loaded
                        try {
                            if (checkLoaded()) { // SUCCESS! our style sheet has loaded
                                clearInterval( interval_id ); // clear the counters
                                clearTimeout( timeout_id );
                                deferredLoader.resolve(); // resolved deferred
                            }
                        } catch(e) {} finally {}
                    }, 10 );                                                   // how often to check if the stylesheet is loaded

                // start counting down till fail
                timeout_id = setTimeout(()=>{
                    clearInterval( interval_id );// clear the counters
                    clearTimeout( timeout_id );
                    head.removeChild( link ); // since the style sheet didn't load, remove the link node from the DOM
                    deferredLoader.fail(); // trigger FAIL if can't load
                }, 10000 );

                head.appendChild( link );  // insert the link node into the DOM and start loading the style sheet

                //return link; // return the link node;
                return deferredLoader;

            } else {
                return true;
            }

        },

        load(fileName) {

            fileName = fileName + '?' + gdConfig.build;

            let found = false;

            _.each(this.loadedFiles,(key,path)=>{
                if (path === fileName) {
                    found = true;
                }
            });

            if (!found) {
                this.loadedFiles.push(fileName);

                const head  = document.getElementsByTagName('head')[0];
                const link  = document.createElement('link');
                link.id   = "css-"+this.loadedFiles.length+1;
                link.rel  = 'stylesheet';
                link.type = 'text/css';
                link.href = fileName;
                link.media = 'all';
                head.appendChild(link);
            }

            return found;


        },

        reload(fileName) {

            let found = false;

            _.each(this.loadedFiles,(key,path)=>{
                if (path === fileName) {
                    found = true;
                }
            });

            if (!found) {
                this.loadedFiles.push(fileName);
            }

            const head  = document.getElementsByTagName('head')[0];
            const link  = document.createElement('link');
            link.id   = "css-"+this.loadedFiles.length+1;
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = fileName;
            link.media = 'all';
            head.appendChild(link);
        },




        loader2018(fileName) {


            fileName = fileName + '?' + gdConfig.build;

            // if we already loaded this file before - do nothing and return true (as def event true is resolved)
            let isFound = false;
            _.each(this.loadedFiles,(key,path)=>{
                if (path === fileName) {
                    isFound = true;
                }
            });

            if (isFound) return true;

            const deferredLoader = Deferred(); // create new deferred object

            // well arguably why not at the end but it guarantee not loading twice if 2 requests go together
            this.loadedFiles.push(fileName);

            const head = document.getElementsByTagName( 'head' )[0]; // reference to document.head for appending/ removing link nodes
            const link = document.createElement( 'link' );           // create the link node

            link.setAttribute('href', fileName );
            link.setAttribute('rel', 'stylesheet' );
            link.setAttribute('type', 'text/css' );

            link.addEventListener('load',()=>{
                deferredLoader.resolve();
            });

            link.addEventListener('error',()=>{
                head.removeChild( link );
                deferredLoader.reject();
            });

            head.appendChild( link );  // insert the link node into the DOM and start loading the style sheet

            //return link; // return the link node;
            return deferredLoader;


        },




    }


};